// Rozpoznanie jazyka dokumentu v prehliadači — presný port utils/lang_detect.py
// (backend) a lang_detect.py (engine), 23. 9. 2026. Pri zmene upraviť všetky tri.
// Overené na judikatúre: 299/300 slovenských rozhodnutí rozpoznaných (1 bol
// anglický rozsudok SD EÚ), 0/300 českých omylom ako slovenských.

const WINDOW = 80;
const MIN_WORDS = 25;
const SK_SHARE = 0.6;
const MIN_SCORE = 0.025;
const MARGIN = 1.5;
const CHAR_WEIGHT = 0.02;

const WORDS = Object.fromEntries(Object.entries({"sk": ["aj", "ako", "aká", "aké", "aký", "alebo", "bol", "bola", "boli", "bolo", "bydlisko", "dalej", "deň", "dna", "dôvod", "dôvodu", "dňa", "dňom", "este", "ešte", "iba", "ju", "ked", "keď", "konania", "ktora", "ktore", "ktorej", "ktorom", "ktorou", "ktory", "ktorá", "ktoré", "ktorého", "ktorí", "ktorý", "ktorým", "len", "mal", "mala", "mali", "medzi", "meno", "mesiacov", "miesto", "moze", "môže", "môžu", "narodenia", "nebol", "nebola", "neboli", "nie", "nájomca", "nájomcu", "nájomné", "oprávnený", "podla", "podľa", "povinná", "povinný", "pozícia", "pracovného", "pracovný", "pred", "predmet", "prenajímateľ", "prenajímateľa", "preto", "pretoze", "pretože", "pri", "priezvisko", "prvý", "práca", "prípade", "rokov", "rozhodnutie", "sa", "skúsenosti", "sme", "so", "som", "spoločnosti", "spoločnosť", "ste", "sumu", "sú", "súd", "súdu", "sťažovateľ", "teda", "tejto", "tieto", "tiez", "tiež", "tohto", "tým", "týmto", "ustanovenia", "vec", "veci", "vo", "vzdelanie", "výške", "všetky", "všetkých", "zamestnanec", "zamestnávateľ", "zamestnávateľa", "zmluvnej", "zmluvné", "zmluvy", "zo", "zručnosti", "čo", "ďalej", "ďalšie", "žalobca", "žalobcu"], "cs": ["bydliště", "byl", "byla", "byli", "bylo", "co", "dale", "další", "den", "dne", "dnem", "dovednosti", "dále", "důvod", "důvodu", "jako", "jaká", "jaké", "jaký", "jen", "jeste", "ještě", "ji", "již", "jméno", "jsem", "jsme", "jsou", "jste", "kdyz", "když", "ktera", "ktere", "kterou", "ktery", "která", "které", "kterého", "kterém", "který", "kterým", "kteří", "let", "mezi", "mohou", "muze", "místo", "měl", "měla", "měli", "měsíců", "může", "narození", "nebo", "nebyl", "nebyla", "nebyli", "není", "nájemce", "nájemné", "oprávněn", "podle", "pouze", "povinen", "pozice", "pracovní", "pracovního", "pronajímatel", "pronajímatele", "proto", "protoze", "protože", "první", "před", "předmět", "při", "příjmení", "případě", "rozhodnutí", "se", "smlouvy", "smluvní", "soud", "soudu", "společnost", "společnosti", "stěžovatel", "své", "také", "tedy", "tohoto", "tyto", "této", "též", "tím", "tímto", "ustanovení", "ve", "vzdělání", "výši", "věc", "věci", "všech", "všechny", "zaměstnanec", "zaměstnavatel", "zaměstnavatele", "zda", "ze", "zkušenosti", "či", "částku", "řízení", "žalobce"], "en": ["agreement", "and", "any", "are", "as", "be", "been", "by", "for", "from", "has", "have", "in", "is", "its", "not", "of", "on", "or", "other", "shall", "such", "than", "that", "the", "their", "this", "to", "were", "which", "will", "with"], "de": ["auch", "auf", "aus", "bei", "das", "dem", "den", "der", "des", "die", "durch", "ein", "eine", "einer", "eines", "für", "gemäß", "im", "ist", "mit", "nach", "nicht", "oder", "sich", "sind", "und", "von", "werden", "wird", "wurde", "zu"], "hu": ["alapján", "az", "azt", "csak", "egy", "ez", "hogy", "illetve", "kell", "között", "lesz", "meg", "mint", "már", "nem", "nincs", "szerint", "után", "vagy", "valamint", "van", "volt", "és"], "pl": ["być", "dla", "ich", "jak", "jego", "jej", "jest", "która", "które", "który", "lub", "może", "nie", "oraz", "przez", "przy", "się", "tylko", "umowy", "zgodnie", "został", "została", "że"]}).map(([k, v]) => [k, new Set(v)]));
const LANGS = ["sk", "cs", "en", "de", "hu", "pl"];
const CHARS = {"sk": "äôľĺŕ", "cs": "ěřů", "pl": "łąęśźżń", "hu": "őű", "de": "ß"};
export const LANG_NAMES = {"sk": "slovenčina", "cs": "čeština", "en": "angličtina", "de": "nemčina", "hu": "maďarčina", "pl": "poľština", "cyr": "jazyk v azbuke"};

const WORD_RE = /\p{L}[\p{L}\p{M}]*/gu;
const CYR_RE = /\p{Script=Cyrillic}/u;

const countChars = (letters, chars) => {
  let n = 0;
  for (const ch of letters) if (chars.includes(ch)) n += 1;
  return n;
};
const cyrShare = (letters) => {
  if (!letters.length) return 0;
  let n = 0;
  for (const ch of letters) if (CYR_RE.test(ch)) n += 1;
  return n / [...letters].length;
};

export const classifyWindow = (words) => {
  if (!words.length) return null;
  const letters = words.join('');
  if (letters && cyrShare(letters) > 0.3) return 'cyr';
  const n = words.length;
  const scores = LANGS.map((lang) => {
    let s = words.filter((w) => WORDS[lang].has(w)).length / n;
    const chars = CHARS[lang];
    if (chars) s += CHAR_WEIGHT * 100 * countChars(letters, chars) / Math.max(1, [...letters].length);
    return [lang, s];
  });
  // stabilné zoradenie ako v Pythone (sorted s reverse=True zachová poradie pri zhode)
  const ranked = scores.map((x, i) => [...x, i]).sort((a, b) => (b[1] - a[1]) || (a[2] - b[2]));
  const [best, s1] = ranked[0];
  const s2 = ranked[1][1];
  if (s1 < MIN_SCORE || s1 < MARGIN * s2) return null;
  return best;
};

export const detectLanguage = (text) => {
  const words = ((text || '').match(WORD_RE) || []).map((w) => w.toLowerCase());
  const undetermined = (reason) => ({ lang: 'undetermined', name: null, sk_share: 0, words: words.length, accepted: false, reason });
  if (words.length < 5) return undetermined('too_little_text');
  const all = words.join('');
  if (cyrShare(all) > 0.3) {
    return { lang: 'cyr', name: LANG_NAMES.cyr, sk_share: 0, words: words.length, accepted: false, reason: 'not_slovak' };
  }
  let counts = {};
  let classified = 0;
  if (words.length < MIN_WORDS) {
    const lang = classifyWindow(words);
    if (lang) { counts[lang] = words.length; classified = words.length; }
  }
  if (words.length >= MIN_WORDS) {
    for (let i = 0; i < words.length; i += WINDOW) {
      const chunk = words.slice(i, i + WINDOW);
      if (chunk.length < MIN_WORDS && i > 0) break;
      const lang = classifyWindow(chunk);
      if (lang) { counts[lang] = (counts[lang] || 0) + chunk.length; classified += chunk.length; }
    }
  }
  if (!classified) {
    const sk = countChars(all, CHARS.sk);
    const cs = countChars(all, CHARS.cs);
    if (sk >= 2 && cs === 0) { counts = { sk: words.length }; classified = words.length; }
    else if (cs >= 2 && sk === 0) { counts = { cs: words.length }; classified = words.length; }
    else return undetermined(words.length < MIN_WORDS ? 'too_little_text' : 'ambiguous');
  }
  // dominantný = prvý s maximom v poradí vloženia (ako max() v Pythone)
  let dominant = null;
  for (const [k, v] of Object.entries(counts)) if (dominant === null || v > counts[dominant]) dominant = k;
  const skShare = (counts.sk || 0) / classified;
  const accepted = skShare >= SK_SHARE;
  return { lang: dominant, name: LANG_NAMES[dominant] || null, sk_share: Math.round(skShare * 1000) / 1000,
    words: words.length, accepted, reason: accepted ? null : 'not_slovak' };
};
